import React, { useState, useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { ReactSession } from 'react-client-session';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Helmet} from "react-helmet";

import '../Dashboard.css';
import classes from "./AddAlbum.module.css";
import styles from '../Dashboard.module.css';

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";

function EditImage() {
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const [image, setImage] = useState([]);
    const [ifDisabled, setIfDisabled] = useState(false);
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get('logged_user');

    const onSubmit = (e) => {
        setIfDisabled(true);
        const toast_id = toast.loading("Please wait...");

        var data = new FormData();
        data.append('user_id', logged_user);
        data.append('album-name', e.title);
        data.append('album-desc', e.description);
        data.append('album-img', image);
        data.append('action', 'ADD_ALBUM');

        // let formObject = Object.fromEntries(data.entries());
        // console.log(formObject);

        axios.post(`${process.env.REACT_APP_API_URL}/api/user/album.php`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then(response => {
                console.log(response.data);
                reset({
                    title: '',
                    description: '',
                });
                setImage([]);

                setIfDisabled(false);
                toast.update(toast_id, {render: response.data.message, autoClose: 5000, type: response.data.status, isLoading: false});
            }).catch(err => {
                console.log(err);
            })
    }

    const onImageChange = (e) => {
        setImage(e.target.files[0]);
    }

    console.log(image);

    return (
        <>
            <Helmet>
                <title>Add Album</title>
            </Helmet>
            <div className="container_wrapper">
                <Header />
                <div className={`${styles.main} main`}>
                    <ToastContainer />
                    <Sidebar />
                    <div className={styles.main_content}>
                        <div className={styles.content_body}>
                        <div className={`${styles.title} mb-4`}>
                            <h5><i className="fa-solid fa-film"></i> Add Album</h5>
                        </div>
                            <div className={styles.card}>
                                <div className="card-body">
                                    <div className={classes.form_wrap}>
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div className="form-group">
                                                <label>Title:</label>
                                                <input {...register('title', {required: true})}  className="form-control" type="text" placeholder="Your album's title" />
                                                {errors.title && <p className={styles.error_msg}>This field cannot be empty</p>}
                                            </div>
                                            <div className="form-group">
                                                <label>Description</label>
                                                <textarea {...register('description', {required: true})} className="form-control" rows="3"></textarea>
                                                {errors.description && <p className={styles.error_msg}>This field cannot be empty</p>}
                                            </div>
                                            <div className="form-group">
                                                <label>Album picture</label>
                                                <input className="form-control" onChange={onImageChange} type="file"  accept="image/*" />
                                            </div>
                                            <div className="form-group mb-0">
                                                <button className="btn btn-primary" type="submit" disabled={ifDisabled}>Create Album</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}

export default EditImage;